import React, { Component } from "react";

import firebase from "../config/firebaseInit";

import swal from "sweetalert";

import Lieu, { Position, Reservation, Service, UserSend } from "../model/lieux";

class JobPage extends Component {

    constructor(props) {
        super(props);
        this.state = { fullName: "", telephone: "", email: "", ville: "", motivation: "" };
        this.onTyping = this.onTyping.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }


    onTyping(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    onSubmit(event) {
        event.preventDefault();

        let db = firebase.firestore();


        let docs = db.collection('job').doc();
        if (!(this.state.fullName.trim() === ""
            && this.state.telephone.trim()
            && this.state.email.trim()
            && this.state.ville.trim()
            && this.state.motivation.trim()
        )) {
            let user = firebase.auth().currentUser;

            if (user != null) {

                let neWDocs = docs.set({
                    fullName: this.state.fullName,
                    telephone: this.state.telephone,
                    email: this.state.email,
                    ville: this.state.ville,
                    motivation: this.state.motivation

                });

                swal({
                    text: "LIEU RAJOUTE AVEC SUCCES",
                    icon: "success",
                })

            }


            this.setState(
                {
                    nom: "",
                    prixMin: "",
                    prixMax: "",
                    adresseExact: "",
                    adresseAprox: "",
                    ville: "",
                    contact: "",
                    description: "",
                    confirmer: false,
                    selectedArrondisement: "",
                    imageUrl: ""
                }
            )
        } else {
            swal({
                text: "Veillez remplir tous les champs",
                icon: "warning",
            })
        }


        document.querySelector(".form").reset();

        return false;
    }


    render() {
        return (
            <div className="container mt-45" >
                <div className="row">
                    <div className="col-12">
                        <h4>Envoyez vos CV</h4>
                        <form className="needs-validation" novalidate>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label for="validationCustom01">Nom (s) et prénom (s)</label>
                                    <input type="text" className="form-control"
                                        value={this.state.fullName} name="fullName"
                                        id="validationCustom01" placeholder="Nom (s) et prénom (s)" required />
                                    <div className="valid-feedback">
                                        Looks good!
                    </div>
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="inputEmail4">Téléphone</label>
                                    <input type="text" value={this.state.telephone}
                                        name="telephone"
                                        className="form-control" id="validationCustom02" placeholder="Téléphone" required />
                                    <div className="valid-feedback">
                                        Looks good!
                    </div>
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="inputEmail4">Email</label>
                                    <input type="text" className="form-control"
                                        value={this.state.email}
                                        name="email"
                                        id="validationCustom02" placeholder="Email" required />
                                    <div className="valid-feedback">
                                        Looks good!
                    </div>
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="inputPassword4">Ville</label>
                                    <select id="inputState" required value={this.state.ville} name="ville" onChange={this.onTyping} className="form-control">
                                        <option value="">Choisir...</option>
                                        <option value="Bouenza">Bouenza</option>
                                        <option value="Kouilou">Kouilou</option>
                                        <option value="Plateaux">Plateaux</option>
                                        <option value="Pointe-Noire">Pointe-Noire</option>
                                        <option value="Lékoumou">Lékoumou</option>
                                        <option value="Likouala">Likouala</option>
                                        <option value="Brazzaville">Brazzaville</option>
                                        <option value="Pool">Pool</option>
                                        <option value="Niari">Niari</option>
                                        <option value="Sangha">Sangha</option>
                                        <option value="Cuvette-Ouest">Cuvette-Ouest</option>
                                        <option value="Cuvette">Cuvette</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="exampleFormControlTextarea1">Lettre de motivation</label>
                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" required name="motivation" value={this.state.motivation}></textarea>
                                </div>
                                <form-group className="col-md-6 mb-3">
                                    <label for="exampleFormControlFile1">CV</label>
                                    
                                </form-group>
                                <button onSubmit={this.state.onSubmit} onClick={this.state.onSubmit} className="btn btn-primary">Soumettre</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );

    }
}

export default JobPage;